export var baseModuleId = 'gn.audio.angularjs-components';
